module.exports = __webpack_public_path__ + "static/img/topBg.798f494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/topBg.png
// module id = aaDT
// module chunks = 0